export default __webpack_public_path__ + "static/media/cdac_logo.86cf2b04.jpg";